import { BrandNotFound } from '@/app/components/BrandNotFound/BrandNotFound'
import SurveyObserver from '@/app/components/SurveyObserver'
import { useIsAvaBasePath } from '@/app/hooks/ava/useAvaVerification'
import { useLocation } from 'react-router-dom'

export default function BrandNotFoundVehiclePageSurvey() {
  const isAva = useIsAvaBasePath()
  const isOnboarding = useLocation().pathname.includes('/onboarding/')
  const redirectLink =
    isAva && isOnboarding
      ? '/ava/onboarding/connect-device/charger/select'
      : '/connect-device/charger/select'
  return (
    <SurveyObserver observedSurveys={['MissingBrand']}>
      <BrandNotFound
        type="vehicle"
        brandPlaceholder="Vehicle Make"
        modelPlaceholder="Vehicle Model"
        redirect={{
          link: redirectLink,
          device: 'charger',
        }}
      />
    </SurveyObserver>
  )
}
